import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getRolesPaginated = ({
  churchId,
  page,
  pageSize,
  isDenomination = false,
  denominationId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/roles-paginated?page=${page}&per_page=${pageSize}`
  );
};

export const useRolesPaginated = ({
  churchId,
  page,
  pageSize,
  isDenomination = false,
  denominationId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "roles",
      page,
      pageSize,
      isDenomination ? denominationId : churchId
    ],
    queryFn: () =>
      getRolesPaginated({
        churchId,
        page,
        pageSize,
        isDenomination,
        denominationId
      })
  });
};
